import React, { useEffect, useRef } from 'react'
import gsap, { Power2 } from 'gsap'
import { ScrollToPlugin } from 'gsap/dist/ScrollToPlugin'
gsap.registerPlugin(ScrollToPlugin)

export function useAnchorScroll (
  ref,
  extraOffset = 0,
  onBeforeScroll = () => {}
) {
  let targets = []

  function handleClick (event) {
    const anchor = event.currentTarget
    const hash = anchor.hash
    const scrollTarget = document.getElementById(hash.replace('#', ''))
    if (!scrollTarget) {
      return
    }
    event.preventDefault()
    const rect = scrollTarget.getBoundingClientRect()
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop
    let offset = Number(
      document.documentElement.style
        .getPropertyValue('--scroll-offset')
        .replace('px', '')
    )
    offset = (isNaN(offset) ? 0 : offset) + (extraOffset || 0)
    const y = rect.top + scrollTop - offset
    onBeforeScroll()
    gsap.to(window, {
      scrollTo: {
        autoKill: false,
        y
      },
      duration: 0.6,
      ease: Power2.easeInOut
    })
  }

  const resetTargets = () => {
    removeClickEventListeners()
    targets = []
    const anchors = ref.current.querySelectorAll('a') || []
    Array.from(anchors).forEach((anchor) => {
      // ハッシュがない場合は対象外
      if (!anchor.hash) return
      // パスが違う場合も対象外
      if (window.location.pathname !== anchor.pathname) return false
      // 二重登録を防止
      if (anchor.hasAttribute('data-use-anchor-scroll')) return

      targets.push(anchor)
      anchor.addEventListener('click', handleClick)
      anchor.setAttribute('data-use-anchor-scroll', '')
    })
  }

  const removeClickEventListeners = () => {
    targets.forEach((anchor) => {
      anchor.removeEventListener('click', handleClick)
      anchor.removeAttribute('data-use-anchor-scroll')
    })
  }

  const update = () => {
    resetTargets()
  }

  useEffect(() => {
    resetTargets()

    return () => {
      removeClickEventListeners()
    }
  }, [ref, extraOffset, onBeforeScroll])

  return {
    update
  }
}

export function AnchorScroll ({
  id,
  className,
  as = 'div',
  extraOffset,
  onBeforeScroll,
  children
}) {
  const Root = as
  const rootRef = useRef(null)
  useAnchorScroll(rootRef, extraOffset, onBeforeScroll)

  return (
    <Root id={id} className={className} ref={rootRef}>
      {children}
    </Root>
  )
}
